// 四大交付模块（对应 PPT 的「定魂 / 定权 / 定局 / 定效」）与服务总览页文案。
// 导航下拉、首页服务卡片、/services 总览页、/services/:moduleId 详情页都从这里取内容，
// 以后改服务口径只需要改这一个文件。

export const MODULES = [
  {
    id: 'family-governance',
    number: '01',
    image: '/optimized/home-service-1.webp',
    heroImage: '/optimized/family-office-advisory-1.webp',
    zh: {
      code: '定魂',
      title: '家族治理与宪章设计',
      navTitle: '家族治理与宪章设计',
      tagline: '提炼家族核心价值观，设计理事会与代际教育机制。',
      heroSubtitle: '宪章不进抽屉，进系统。',
      imageCaption: '让家族不依赖某一个人，而依赖体系。',
      // 「从纸面到系统」：只写 Omni 已上线、可在代码中核实的能力，未上线的不写
      system: {
        title: '宪章里写的，系统里照着办',
        points: [
          { label: '限额', text: '每 4 小时自动检查，越限即提醒' },
          { label: '签批', text: '调整建议须负责人签批，记录留档' },
          { label: '时限', text: '申报、审计、KYC 到期前自动提醒' },
          { label: '档案', text: '宪章、遗嘱、授权书一处归档' }
        ],
        cta: '了解 MuRRÓN Omni'
      },
      // 服务条目只显示标题，点开看详情
      compactItems: true,
      sectionTitle: '战略实施',
      sectionSubtitle: '从愿景、制度、结构、执行四个层面，为家族建立完整的治理框架，使家族从「人治」进入「制度化」。',
      deliverables: ['《家族宪章（中英双语版）》', '《委员会授权矩阵》'],
      items: [
        {
          title: '1. 家族愿景与价值体系构建',
          description: '我们通过结构化的方法，帮助家族明确：家族愿景（Family Vision）、家族使命（Family Mission）、家族核心价值观（Family Values）、家族精神与文化（Family Ethos）、家族的长期目标（100-year legacy positioning）。这些不是「漂亮的口号」，而是会直接影响：资产配置方向、下一代教育方式、家族企业接班策略、投资风格与风险偏好、家族文化的代际延续。最终形成家族的「精神宪法」。'
        },
        {
          title: '2. 家族宪章完整编制',
          description: '家族宪章是一个跨代制度体系，其本质是家族的最高治理文件。我们协助编制的宪章包含：治理架构部分（家族委员会、投资委员会、继承委员会、慈善委员会）、制度部分（决策机制与投票制度、权责边界、争议解决机制、资产使用原则、重大事项「一票否决」条款、任职资格与利益冲突制度）、家族参与机制（二代三代的治理教育、宪章年度复审制度、家族年会制度化、家族沟通机制）。家族宪章用于：避免家族冲突、防止资产争议、保证治理秩序、让每一代人清楚自己的责任。'
        },
        {
          title: '3. 家族理事会与委员会体系',
          description: '我们协助家族「构建一个可运营的治理体系」：（1）家族委员会（Family Council）决定家族的重大方向、管控家族资产与风险、推进治理与教育。我们协助编制章程、角色分工、年度会议机制、决策流程与信息透明制度。（2）继承委员会（Next-Gen Committee）解决二代、三代的参与问题：如何参与、参与什么、何时参与、如何评估能力、如何逐步承接责任。（3）慈善委员会（Philanthropy Committee）制定家族慈善方向、设立家族基金会，让下一代参与「超越财富的责任」。各委员会的权限边界统一写入《委员会授权矩阵》。'
        },
        {
          title: '4. 家族沟通机制',
          description: '家族内部沟通失效是家族冲突的关键来源。我们为家族设计结构化沟通体系：家族年度大会（Family Assembly）、季度信息披露体系、家族简报（Family Newsletter）、冲突调解流程、授权体系（Delegation Matrix）、家族企业与家族资产之间的沟通接口。让「信息透明、角色清晰」成为家族文化的一部分。'
        },
        {
          title: '5. 二代、三代培养体系',
          description: '根据家族成员的实际特点（海外教育背景、投资意愿、自我价值诉求），我们为下一代设计：角色定位（Role Definition）、能力路径图（Skills Roadmap）、海外教育与职业规划、投资训练（Investment Literacy）、家族企业参与机制与评估标准、多代共治框架。目标不是培养「继承人」，而是培养「合格的治理参与者」：接班是选项，安全是底线。'
        },
        {
          title: '6. 家族文化与传承系统',
          description: '财富终有尽时，但「文化」才能真正传承。我们协助家族建立：家族历史记录与族谱整理、家族精神故事（Family Narratives）、家族仪式（Family Rituals）、家族典章（Principles）、家族口述历史项目、家族品牌（Family Identity）。目的是让家族文化成为家族成员身份认同的核心。'
        },
        {
          title: '7. 家族治理长期陪伴',
          description: '家族治理不是项目，而是一个持续工程。我们提供：年度治理回顾、宪章升级迭代、决策体系优化、新一代成员加入机制、顾问列席家族会议、第三方观察员（Independent Observer）角色。最终形成一个可以运行几十年的完整家族治理系统。'
        }
      ]
    },
    en: {
      code: 'Purpose',
      title: 'Family Governance & Constitution',
      navTitle: 'Family Governance & Constitution',
      tagline: "Distil the family's core values; design the council and next-generation education mechanisms.",
      heroSubtitle: 'A constitution belongs in the system, not in a drawer.',
      imageCaption: 'A family that relies on systems, not on any single person.',
      system: {
        title: 'Written in the constitution, carried out in the system',
        points: [
          { label: 'Limits', text: 'Checked every four hours, with an alert on any breach' },
          { label: 'Sign-off', text: 'Every proposed change goes to the principal for sign-off, on record' },
          { label: 'Deadlines', text: 'Filings, audits and KYC flagged before they fall due' },
          { label: 'Records', text: 'Constitution, wills and powers of attorney in one place' }
        ],
        cta: 'Explore MuRRÓN Omni'
      },
      compactItems: true,
      sectionTitle: 'What We Build',
      sectionSubtitle: 'Across vision, institutions, structure and execution, we establish a complete governance framework that moves the family from rule by individuals to rule by institutions.',
      deliverables: ['Family Constitution (bilingual Chinese and English)', 'Committee Authority Matrix'],
      items: [
        {
          title: '1. Vision, Mission & Values',
          description: "Through a structured process we help the family articulate its Vision, Mission, Values, Ethos and 100-year legacy positioning. These are not slogans: they directly shape asset allocation, next-generation education, business succession, investment style and risk appetite, and the continuity of family culture. Together they form the family's constitutional spirit."
        },
        {
          title: '2. The Family Constitution',
          description: "The Family Constitution is a multi-generational institutional framework and the family's supreme governance document. The constitutions we draft cover governance architecture (Family Council, Investment Committee, Next-Gen Committee, Philanthropy Committee), institutional rules (decision and voting systems, authority boundaries, dispute resolution, principles for asset use, veto rights on major matters, eligibility and conflict-of-interest rules) and participation mechanisms (next-generation governance education, annual constitutional review, institutionalised family assemblies, communication protocols). It exists to prevent conflict and asset disputes, preserve order and make every generation clear about its responsibilities."
        },
        {
          title: '3. Family Council & Committee System',
          description: "We help the family build an operable governance system: (1) a Family Council that sets major direction, oversees family assets and risk and drives governance and education, with its charter, roles, annual meeting cycle, decision process and transparency rules; (2) a Next-Gen Committee that settles how, when and in what the second and third generations participate, how capability is assessed and how responsibility is handed over; (3) a Philanthropy Committee that sets the family's philanthropic direction and establishes the family foundation, engaging the next generation in responsibilities beyond wealth. The authority of every committee is written into a single Committee Authority Matrix."
        },
        {
          title: '4. Family Communication Protocol',
          description: 'Breakdown of communication is the root of most family conflict. We design a structured communication system: the annual Family Assembly, quarterly disclosure, a family newsletter, conflict mediation procedures, a delegation matrix, and clear interfaces between the family business and family assets, so that transparency and clarity of roles become part of the family culture.'
        },
        {
          title: '5. Next-Generation Development',
          description: 'Based on who the next generation actually are, often educated abroad, interested in investing and keen to build their own identity, we design role definitions, a skills roadmap, education and career planning, investment literacy training, participation and evaluation standards for the family business, and a multi-generational co-governance model. The aim is not to produce heirs but qualified governance participants: succession is an option, security is the baseline.'
        },
        {
          title: '6. Family Culture & Legacy System',
          description: 'Wealth can be spent; culture is what truly endures. We help the family build its historical record and genealogy, family narratives, rituals, principles, an oral-history project and a family identity, so that culture becomes the core of how members understand who they are.'
        },
        {
          title: '7. Ongoing Governance Stewardship',
          description: 'Governance is not a project but a continuing practice. We provide annual governance reviews, constitutional upgrades, optimisation of the decision system, onboarding of new members, advisor attendance at family meetings and an Independent Observer role, so that the governance system keeps running for decades.'
        }
      ]
    }
  },
  {
    id: 'corporate-governance',
    number: '02',
    image: '/optimized/home-service-2.webp',
    heroImage: '/optimized/home-about-2.webp',
    zh: {
      code: '定权',
      title: '公司治理与决策体系',
      navTitle: '公司治理与决策体系',
      tagline: '搭建董事会、投资委员会（IC）及底层风控内控制度。',
      heroSubtitle: '接班不是让后代深陷日常运营的泥沼，而是让他坐上顶层，成为手握规则的资本监督者。所有权与经营权分离，用授权矩阵把权与责写清楚。',
      imageCaption: '让后代坐在裁判席上，而不是球场上。',
      sectionTitle: '战略实施',
      sectionSubtitle: '先把所有权与经营权分开，再把权与责写进全家都看得见的规则里。',
      deliverables: ['《决策授权矩阵》', '《投后管理与绩效分析手册》'],
      items: [
        {
          title: '1. 所有权与经营权分离',
          description: '家族成员退出实业的日常管理（CEO、COO 职位），转而聘请职业经理人团队。这不是放弃，而是放权：家族通过董事会席位保留对重大战略、分红政策和高管任免的控制权（Ownership），将经营权（Management）交付给更专业的人。我们协助设计董事会结构、席位安排与保留事项清单。'
        },
        {
          title: '2. 投资委员会与决策框架',
          description: '我们设计稳健的投资治理系统，包括委员会结构、投票机制、风险监督流程和标准化评估框架。这些系统确保纪律性，减少对关键人物的依赖，使家族能够在市场周期中做出一致的、基于证据的决策。我们协助制定 IC 章程、建立风险预算与组合结构、组织季度 IC 会议、出具 IC 年度报告。'
        },
        {
          title: '3. 决策授权矩阵与风控内控',
          description: '谁能决定什么、到什么额度、需要谁复核，我们把这些写进《决策授权矩阵》，并配套底层风控内控制度与定期绩效仪表盘。后代无需精通尽调，只需按规则签字，即可有效防范管理层的道德风险与利益输送。'
        },
        {
          title: '4. 投后管理与绩效分析',
          description: '为家族控股的企业与投资建立投后管理机制：季度经营与投资回顾、关键指标仪表盘、预算与资金使用审查、重大偏离的升级与处置流程，沉淀为《投后管理与绩效分析手册》。'
        },
        {
          title: '5. 家族办公室运营与长期治理支持',
          description: '我们为家族办公室提供长期、日常、结构化的协调与执行支持，确保治理体系有效落地、信息组织清晰、跨机构合作顺畅。\n\n服务内容包括：\n• 家族办公室运营体系与流程设计\n• 信息与档案治理系统搭建\n• 银行、律师、信托机构等多机构协同\n• 家族会议组织、报告包与信息呈递\n• 年度审查与长期治理延续支持'
        }
      ]
    },
    en: {
      code: 'Authority',
      title: 'Corporate Governance & Decision Systems',
      navTitle: 'Corporate Governance & Decision Systems',
      tagline: 'Build the board, the investment committee and the underlying risk and internal-control rules.',
      heroSubtitle: 'Succession does not mean dragging the next generation into daily operations. It means seating them at the top as the holders of the rules. Separate ownership from management, and write authority and accountability into a matrix everyone can see.',
      imageCaption: "Put the next generation in the referee's chair, not on the pitch.",
      sectionTitle: 'What We Build',
      sectionSubtitle: 'Separate ownership from management first, then write authority and accountability into rules the whole family can see.',
      deliverables: ['Decision Authority Matrix', 'Post-Investment Management & Performance Analysis Handbook'],
      items: [
        {
          title: '1. Separating Ownership from Management',
          description: 'Family members step back from day-to-day executive roles and appoint a team of professional managers. This is delegation, not abandonment: through board seats the family retains control over major strategy, dividend policy and senior appointments, while handing management to those best suited to it. We design the board structure, seat allocation and the list of reserved matters.'
        },
        {
          title: '2. Investment Committees & Decision Frameworks',
          description: 'We design robust investment governance: committee structures, voting mechanisms, risk oversight processes and standardised evaluation frameworks. These systems ensure discipline, reduce key-person dependency and allow the family to make consistent, evidence-based decisions across market cycles. We draft the IC charter, set risk budgets and portfolio structure, run quarterly IC meetings and produce the annual IC report.'
        },
        {
          title: '3. Decision Authority Matrix & Internal Controls',
          description: 'Who may decide what, up to which amount, and who must review: we write this into a Decision Authority Matrix, supported by underlying risk and internal-control rules and a periodic performance dashboard. The next generation does not need to master due diligence; signing by the rules is enough to guard against management moral hazard and tunnelling.'
        },
        {
          title: '4. Post-Investment Management & Performance Analysis',
          description: 'We establish post-investment management for family-controlled businesses and investments: quarterly operating and investment reviews, key-metric dashboards, budget and capital-use review, and escalation procedures for material deviations, consolidated into a Post-Investment Management & Performance Analysis Handbook.'
        },
        {
          title: '5. Family Office Operations & Ongoing Governance Support',
          description: 'We provide long-term, day-to-day, structured coordination and execution support so that governance is actually carried out, information is organised and multi-advisor cooperation runs smoothly.\n\nOur support includes:\n• Family office operating models and workflow design\n• Information governance and document systems\n• Multi-advisor coordination across banks, lawyers and trustees\n• Family meeting facilitation and reporting packages\n• Annual reviews and long-term continuity support'
        }
      ]
    }
  },
  {
    id: 'asset-structuring',
    number: '03',
    image: '/optimized/home-service-3.webp',
    heroImage: '/optimized/wealth-planning-1.webp',
    zh: {
      code: '定局',
      title: '资产架构与配置管理',
      navTitle: '资产架构与配置管理',
      tagline: '跨境税务筹划、信托路径选型与长期战略资产配置（SAA）。',
      heroSubtitle: '结构先于投资。在法律与架构层面，为「企业经营的高风险暴露」与「家族底座财富」之间设立坚不可摧的防火墙，再在架构之上确定长期资产配置。',
      imageCaption: '结构先于投资 · Structure before Investment',
      sectionTitle: '战略实施',
      sectionSubtitle: '在法律与架构层面为企业经营风险与家族底座财富之间设立防火墙，并在架构之上确定长期配置。',
      deliverables: ['《家族资产架构与信托规划方案》', '《投资政策书（IPS）》'],
      items: [
        {
          title: '1. 离岸顶层架构设计',
          description: '我们设计 HoldCo / SPV / OpCo 顶层持股架构，比较香港、新加坡、阿联酋、BVI、开曼等法域的适用性，兼顾税务效率、治理清晰度与资产保护，并明确股东结构、控制路径与资金回流路线，实现企业风险与家族底座资产的法律隔离。\n\n服务内容包括：\n• HoldCo / SPV / OpCo 架构设计\n• 法域对比分析与适用性判断\n• 实质性要求与治理体系搭建\n• 股东结构、控制路径与协议辅导\n• 再投资、退出与资金回流路径规划'
        },
        {
          title: '2. 跨境税务筹划与申报合规',
          description: '我们协助家族理解和管理在多个司法辖区生活、投资与持有资产的税务影响，并与各地专业税务、法律机构协同，设计合规且前瞻性的税务框架，降低跨境风险并支持长期的流动性与结构优化。\n\n服务内容包括：\n• 全球税务风险与税务暴露图谱\n• 股息、利息、资本利得的跨境流转规划\n• 企业与个人税务的整体协调\n• CRS / FATCA 申报合规协同\n• 居留规划、跨境迁移与长期布局'
        },
        {
          title: '3. 香港家族办公室税务架构',
          description: '符合条件的家族投资控股工具（FIHV）可依规申索 0% 利得税；香港亦无遗产税、资本增值税及股息预扣税，资金进出自由。我们协助家族对照法定门槛搭建合资格架构，监督本地律所与私行落地，依规申索法定税务优惠。\n\n核心门槛：\n• 家族持股 ≥ 95%\n• 合资格资产净值 ≥ 2.4 亿港元\n• 在港 2 名全职合资格雇员\n• 每年 200 万港元本地营运开支\n\n香港实行自我评估申索制，无须事前批文；最终以税务局认定为准。'
        },
        {
          title: '4. 信托路径选型与遗产规划',
          description: '我们为家族设计稳健的跨代传承结构，包括信托、基金会与遗产传承安排，实现资产保护、治理制度化与价值观延续。我们聚焦于结构适配性与治理对齐，并与受托人、法律与税务机构紧密协作。\n\n服务内容包括：\n• 信托与基金会的适用性分析\n• Grantor / Non-Grantor / Hybrid 结构评估\n• 受益人治理与分配机制设计\n• 遗产传承规划与承接路径\n• 与受托人、家族办公室、律师等多方协作'
        },
        {
          title: '5. 战略资产配置与投资政策书',
          description: '在架构之上，为家族制定长期战略资产配置（SAA）：以家族目标、流动性需求与风险承受度为起点，设定各资产类别的目标区间与再平衡规则，并形成《投资政策书（IPS）》，作为后续一切投资执行的边界与准绳。'
        }
      ]
    },
    en: {
      code: 'Structure',
      title: 'Asset Structuring & Allocation',
      navTitle: 'Asset Structuring & Allocation',
      tagline: 'Cross-border tax planning, trust pathway selection and long-term strategic asset allocation.',
      heroSubtitle: "Structure before investment. At the legal and structural level we build a firewall between the operating business's risk exposure and the family's core wealth, then set long-term allocation on top of that structure.",
      imageCaption: 'Structure before Investment',
      sectionTitle: 'What We Build',
      sectionSubtitle: "A legal and structural firewall between operating-business risk and the family's core wealth, with long-term allocation built on top of it.",
      deliverables: ['Family Asset Structure & Trust Planning Proposal', 'Investment Policy Statement (IPS)'],
      items: [
        {
          title: '1. Offshore Top-Level Structuring',
          description: 'We design the HoldCo / SPV / OpCo architecture, compare the suitability of Hong Kong, Singapore, the UAE, the BVI, the Cayman Islands and other jurisdictions, balance tax efficiency with governance clarity and asset protection, and define shareholder structure, control pathways and repatriation routes, so that business risk is legally separated from the family\'s core assets.\n\nOur support includes:\n• HoldCo / SPV / OpCo architecture\n• Jurisdiction comparison and suitability analysis\n• Substance requirements and governance design\n• Shareholder alignment and control pathways\n• Reinvestment, exit and repatriation planning'
        },
        {
          title: '2. Cross-Border Tax Planning & Reporting Compliance',
          description: 'We help the family understand and manage the tax consequences of living, investing and holding assets across jurisdictions. Working with local tax and legal professionals, we design compliant, forward-looking frameworks that reduce risk and support long-term mobility and structural efficiency.\n\nOur support includes:\n• Global tax exposure mapping and risk identification\n• Cross-border flow planning for dividends, interest and capital gains\n• Personal and corporate tax alignment\n• CRS / FATCA reporting coordination\n• Residency, mobility and jurisdictional planning'
        },
        {
          title: '3. Hong Kong Family Office Tax Structure',
          description: 'A qualifying family-owned investment holding vehicle (FIHV) may claim a 0% profits tax rate under the Hong Kong regime; Hong Kong also levies no estate duty, capital gains tax or dividend withholding tax, and capital moves freely. We help the family build a qualifying structure against the statutory thresholds, oversee local law firms and private banks through implementation, and claim the statutory concessions in accordance with the rules.\n\nKey thresholds:\n• Family ownership of at least 95%\n• Qualifying net asset value of at least HK$240 million\n• Two full-time qualifying employees in Hong Kong\n• Annual local operating expenditure of HK$2 million\n\nHong Kong operates a self-assessment regime with no advance approval; the final position rests with the Inland Revenue Department.'
        },
        {
          title: '4. Trust Pathway & Estate Planning',
          description: 'We design robust multi-generational transfer structures, including trusts, foundations and estate arrangements, that protect assets, institutionalise governance and preserve family intent. We focus on suitability and governance alignment and work closely with trustees, lawyers and tax advisors.\n\nOur support includes:\n• Trust versus foundation suitability analysis\n• Grantor, non-grantor and hybrid structure assessment\n• Beneficiary governance and distribution mechanisms\n• Estate-transfer planning and inheritance pathways\n• Coordination with trustees, fiduciaries and legal advisors'
        },
        {
          title: '5. Strategic Asset Allocation & Investment Policy Statement',
          description: "On top of the structure we set the family's long-term strategic asset allocation (SAA): starting from family objectives, liquidity needs and risk tolerance, we define target ranges for each asset class and the rebalancing rules, and record them in an Investment Policy Statement that becomes the boundary and yardstick for all subsequent execution."
        }
      ]
    }
  },
  {
    id: 'investment-execution',
    number: '04',
    image: '/optimized/home-service-4.webp',
    heroImage: '/optimized/investment-advisory-1.webp',
    zh: {
      code: '定效',
      title: '投资执行与业绩分析',
      navTitle: '投资执行与业绩分析',
      tagline: '建立涵盖股权、对冲基金等八大资产类别的分析估值与复盘机制。',
      heroSubtitle: '把投资政策落到每一笔执行。作为家族的外包首席投资官（OCIO），我们覆盖股权、对冲基金等八大资产类别的分析、估值与复盘，让业绩可归因、可问责。',
      imageCaption: '交付的不是建议，而是可问责的执行。',
      sectionTitle: '战略实施',
      sectionSubtitle: '作为家族的外包首席投资官（OCIO），把《投资政策书》转化为覆盖八大资产类别的纪律化、可问责的执行。',
      deliverables: ['《资产类别分析体系报告》', '《季度复盘与业绩归因模板》'],
      items: [
        {
          title: '1. OCIO 的角色与边界',
          description: '我们把《投资政策书》落到每一笔执行：资产类别研究、管理人筛选与尽调、交易与配置建议、持续监控与复盘。我们不销售产品、不收取通道费，彻底剥离卖方利益立场；决策权始终在家族的投资委员会，我们是家族最懂行的「买方监军」。'
        },
        {
          title: '2. 全球二级市场',
          description: '我们通过结构化研究、基金对比分析与管理人筛选，协助家族评估全球公开市场机会，确保投资方向与家族的长期目标保持一致。\n\n服务内容包括：\n• 股票与债券策略分析\n• 基金尽职调查与横向比较\n• 私人银行与对冲基金管理人筛选\n• 投资组合审查、多元化评估与风险诊断\n• 业绩监控与外部报告的核实验证'
        },
        {
          title: '3. 一级与私募市场',
          description: '我们在风险投资、私募股权、私募信贷与联合投资方面提供系统化支持，以符合投资委员会标准的尽调框架与评估体系，帮助家族以清晰、纪律化的方式审视私募市场机会。\n\n服务内容包括：\n• 基于商业与财务分析的项目评估\n• 全范围定性尽职调查\n• 投资条款（Term Sheet）审阅与治理对齐\n• 联合投资结构设计建议\n• 按投资委员会标准进行的流程监督'
        },
        {
          title: '4. 房地产与实体资产',
          description: '我们基于资产类别对比模型、底层承做逻辑审视与管理人、运营方筛选，协助家族评估房地产及实体资产机会，确保家族充分理解资产类别特性、风险驱动因素与长期适配性。\n\n服务内容包括：\n• 资产类别对比与适配性分析\n• 底层承做逻辑（Underwriting）与风险因素审查\n• 管理人、运营商与合作伙伴筛选\n• 流动性分析与退出路径评估'
        },
        {
          title: '5. 执行、复盘与业绩归因',
          description: '我们通过透明的执行记录、结构化绩效检视与持续监控机制强化纪律性，运用资金加权收益（MWR）还原真实投资绩效，穿透非标资产的流动性风险，让每一个资产类别都可归因、可问责。\n\n服务内容包括：\n• 投资执行记录与文件体系\n• 季度复盘与业绩归因模板\n• 风险监测与投资政策偏离诊断\n• 外部管理人报告验证与监督'
        },
        {
          title: '6. 稀缺资产触达',
          description: '依托全球头部另类资产通道与机构生态，协助家族触达常规财富管理难以进入的顶尖多策略对冲基金、私募股权份额与联合投资机会。可触达的具体标的与份额，视各基金当期开放情况及投资者适格条件而定。'
        }
      ]
    },
    en: {
      code: 'Performance',
      title: 'Investment Execution & Performance',
      navTitle: 'Investment Execution & Performance',
      tagline: 'Analysis, valuation and review mechanisms across eight asset classes, from equities to hedge funds.',
      heroSubtitle: "Turning the investment policy into every single execution. As the family's outsourced chief investment officer (OCIO), we cover analysis, valuation and review across eight asset classes, from equities to hedge funds, so that performance can be attributed and held to account.",
      imageCaption: 'Not advice, but accountable execution.',
      sectionTitle: 'What We Build',
      sectionSubtitle: "As the family's outsourced chief investment officer, we turn the Investment Policy Statement into disciplined, accountable execution across eight asset classes.",
      deliverables: ['Asset-Class Analysis Framework Report', 'Quarterly Review & Performance Attribution Templates'],
      items: [
        {
          title: '1. The OCIO Role and Its Boundaries',
          description: "We take the Investment Policy Statement into every execution: asset-class research, manager selection and due diligence, trade and allocation recommendations, ongoing monitoring and review. We sell no products and take no distribution fees, so we sit entirely on the family's side of the table. Decision rights always remain with the family's investment committee; we act as its most knowledgeable buy-side gatekeeper."
        },
        {
          title: '2. Public Markets',
          description: "We help the family evaluate global public-market opportunities through structured research, fund comparison and manager screening, keeping the portfolio aligned with the family's long-term objectives.\n\nOur support includes:\n• Equity and bond strategy analysis\n• Fund due diligence and comparative evaluation\n• Manager selection across private banks and hedge funds\n• Portfolio review, diversification assessment and risk diagnostics\n• Performance monitoring and validation of third-party reporting"
        },
        {
          title: '3. Private Markets',
          description: 'We provide systematic support across venture capital, private equity, private credit and co-investment, using rigorous due-diligence frameworks and IC-aligned evaluation standards so that the family can assess private-market exposure with clarity and discipline.\n\nOur support includes:\n• Deal evaluation supported by commercial and financial analysis\n• Full-scope qualitative due diligence\n• Term-sheet review and governance alignment\n• Co-investment structuring guidance\n• Process oversight aligned with investment committee standards'
        },
        {
          title: '4. Real Assets',
          description: 'We help the family evaluate real-asset opportunities using comparative frameworks, underwriting-logic review and manager and operator screening, so that the family understands asset-class fundamentals, risk drivers and long-term suitability within its allocation.\n\nOur support includes:\n• Asset-class comparison and suitability analysis\n• Underwriting logic and risk-factor review\n• Manager, operator and partner screening\n• Liquidity and exit-pathway assessment'
        },
        {
          title: '5. Execution, Review & Performance Attribution',
          description: 'We reinforce discipline through transparent execution records, structured performance reviews and continuous monitoring. Money-weighted returns (MWR) restore the true picture of investment performance and look through the liquidity risk of non-standard assets, so that every asset class can be attributed and held to account.\n\nOur support includes:\n• Investment-execution logs and documentation\n• Quarterly review and performance attribution templates\n• Risk monitoring and policy-drift diagnostics\n• Validation and oversight of external manager reporting'
        },
        {
          title: '6. Access to Scarce Assets',
          description: 'Drawing on leading global alternative-asset channels and an institutional network, we help the family reach top multi-strategy hedge funds, private-equity allocations and co-investment opportunities that are hard to access through conventional wealth management. Specific opportunities and allocations depend on each fund\'s current availability and the investor\'s eligibility.'
        }
      ]
    }
  }
];

// /services 总览页文案
export const SERVICES_PAGE = {
  zh: {
    hero: {
      overline: '我们的服务 · What We Do',
      title: '离岸顶层架构与专属 OCIO 解决方案',
      subtitle: '结构先于投资 · Structure before Investment',
      intro: '单一防线已经失效，家族需要的是一套系统。我们把系统搭建工程拆解为四大核心模块，可全盘统筹推进，亦可按需单独立项；每一阶段以实质性的架构蓝图与规则矩阵为交割标准，确认后付款。'
    },
    modulesTitle: '四大交付模块',
    modulesSubtitle: '魂、权、局、效：以可见的制度凭证与数字底座，把家族战略转化为确定的控制权。',
    deliverablesLabel: '制度交付凭证',
    learnMore: '查看模块详情',
    otherModules: '其他模块',
    startHere: {
      overline: '合作起手式',
      title: '先理清糊涂账，再搭好税务防火墙',
      text: '第一步不是让您动钱，而是先把家底和税务结构盘清楚。您现有的智囊团队不会被取代，税务结构与落地监督由我们补上。',
      steps: [
        {
          title: '盘清糊涂账',
          text: '在不挪动您一分钱的前提下，彻底盘点散落全球的股权、私行账户与代持资产，建立上帝视角。'
        },
        {
          title: '搭建税务防火墙',
          text: '穿透现有复杂持股，重构合规的家办税务架构：在 CRS 全球透明化时代守住申报合规、消除双重征税与稽查隐患，把税负损耗降到法定框架内的最低。'
        }
      ],
      deliverablesTitle: '核心交付',
      deliverables: ['《家族资产底账》', '《家办顶层税务结构与合规排雷方案》'],
      cta: '预约闭门会',
      ctaNote: '《家族资产底账盘点与税务合规摸底闭门会》：不动钱、不签约。'
    },
    omni: {
      overline: '科技底座',
      title: 'MuRRÓN Omni 家族数字大脑',
      text: '十大类资产与法律架构一屏全揽；直连全球资本市场与权威私募基准数据库，自动输出机构级家族报告。AI 仅作为「数字幕僚」提供草稿与解析，一切核心指令须经人工授权；单一家族专属私有化部署，数据主权归家族。',
      assets: ['股票', '固收', 'PE / VC', '私募信贷', '对冲基金', '房地产', '大宗商品', '数字资产', '艺术品', '现金'],
      cta: '了解 MuRRÓN Omni'
    },
    closing: {
      slogan: 'Beyond Contracts, Trusted for Generations.',
      quote: '我们交付的不是咨询建议，而是为家族量身定制、可立刻运转的「法律契约」与「底层操作手册」。',
      title: '结构筑牢防火墙，执行锁定控制权。',
      cta: '预约闭门会'
    },
    note: '税务优惠须符合法定条件并依规申索，最终以主管税务机关认定为准。本页内容不构成法律、税务或投资意见。'
  },
  en: {
    hero: {
      overline: 'What We Do',
      title: 'Bespoke Offshore Structuring & OCIO Solutions',
      subtitle: 'Structure before Investment',
      intro: 'A single line of defence no longer works; what a family needs is a system. We break the build into four core modules that can be run as one programme or commissioned individually. Each stage closes against a substantive architecture blueprint and rule matrix, with payment on sign-off.'
    },
    modulesTitle: 'Four Delivery Modules',
    modulesSubtitle: 'Purpose, authority, structure, performance: tangible institutional deliverables and a digital backbone that turn family strategy into certain control.',
    deliverablesLabel: 'Institutional deliverables',
    learnMore: 'View module',
    otherModules: 'Other modules',
    startHere: {
      overline: 'Where We Start',
      title: 'Clear the books first, then build the tax firewall',
      text: 'The first step is not moving your money. It is getting a clear picture of the family balance sheet and its tax structure. Your existing advisors are not replaced; we add the tax structure and the oversight of implementation.',
      steps: [
        {
          title: 'Map the balance sheet',
          text: 'Without moving a single dollar, we take a full inventory of equity stakes, private-bank accounts and nominee holdings scattered around the world, and build one top-down view.'
        },
        {
          title: 'Build the tax firewall',
          text: 'We look through the existing holding chain and rebuild a compliant family-office tax structure: staying on the right side of CRS reporting, removing double taxation and audit exposure, and bringing tax leakage down to the minimum the law allows.'
        }
      ],
      deliverablesTitle: 'Core deliverables',
      deliverables: ['Family Asset Ledger', 'Top-Level Family Office Tax Structure & Compliance Review'],
      cta: 'Book a closed-door session',
      ctaNote: 'A closed-door session to map the family balance sheet and tax position. No money moves and nothing is signed.'
    },
    omni: {
      overline: 'Technology backbone',
      title: "MuRRÓN Omni: the family's digital brain",
      text: 'Ten asset classes and the legal structure on one screen. Direct links to global markets and institutional private-market benchmarks, with institution-grade family reporting generated automatically. AI acts only as a digital chief of staff that drafts and explains; every core instruction requires human authorisation. Deployed privately for a single family, so data sovereignty stays with the family.',
      assets: ['Equities', 'Fixed Income', 'PE / VC', 'Private Credit', 'Hedge Funds', 'Real Estate', 'Commodities', 'Digital Assets', 'Art', 'Cash'],
      cta: 'Explore MuRRÓN Omni'
    },
    closing: {
      slogan: 'Beyond Contracts, Trusted for Generations.',
      quote: 'What we deliver is not advice. It is a set of legal covenants and operating manuals, tailored to the family and ready to run from day one.',
      title: 'Structure builds the firewall. Execution locks in control.',
      cta: 'Book a closed-door session'
    },
    note: 'Tax concessions are subject to statutory conditions and must be claimed in accordance with the rules; the final position rests with the relevant tax authority. Nothing on this page constitutes legal, tax or investment advice.'
  }
};
